export default __webpack_public_path__ + "static/media/vd-screenshot-api.518d3549.png";